import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-ink text-ivory border-t border-ivory/10" data-testid="site-footer">
    <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-16 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12">
        <img src="/nk-logo-light.png" alt="NK Bridal Australia" className="h-20 md:h-28 w-auto" />
        <p className="font-serif italic text-2xl md:text-3xl text-ivory/80 max-w-sm md:text-right">
          Couture wedding gowns, made by hand — Perth &amp; Australia-wide.
        </p>
      </div>
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 border-t border-ivory/15 pt-10">
        <div className="flex flex-wrap gap-8 text-xs uppercase tracking-[0.25em]">
          <Link to="/collections" data-testid="footer-collections" className="link-underline">Collections</Link>
          <Link to="/process" data-testid="footer-process" className="link-underline">Process</Link>
          <Link to="/alterations" data-testid="footer-alterations" className="link-underline">Alterations</Link>
          <Link to="/about" data-testid="footer-about" className="link-underline">About</Link>
          <Link to="/contact" data-testid="footer-contact" className="link-underline">Book</Link>
          <a href="https://www.instagram.com/nkbridalaustralia/" target="_blank" rel="noreferrer" data-testid="footer-instagram" className="link-underline">Instagram</a>
        </div>
        <p className="text-xs text-ivory/40 tracking-wide">© {new Date().getFullYear()} NK Bridal Australia · Perth, Western Australia · Australia-wide</p>
      </div>
    </div>
  </footer>
);
